module.exports = __webpack_public_path__ + "media/images/front/common/icon_watched-d01bbde96b53b498b063a52f91a08a07.svg";